export const TRAIT_CATEGORIES = [
    'Reliability & Competitiveness',
    'Teamwork & Leadership',
    'Poise',
    'Confidence',
    'Agreeableness',
    'Coachability',
    'Accountability',
    'Resiliency',
  ];